import { render, staticRenderFns } from "./EditBasic.vue?vue&type=template&id=3e3090a8&scoped=true&"
import script from "./EditBasic.vue?vue&type=script&lang=js&"
export * from "./EditBasic.vue?vue&type=script&lang=js&"
import style0 from "./EditBasic.vue?vue&type=style&index=0&id=3e3090a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3090a8",
  null
  
)

export default component.exports